/* eslint-disable */
import {
  Brands_Params,
  Terms_Conditions_Params,
  MDM_Entity_params,
  AttachmentParams,
  CommentsParams,
  PurchaseOrderParams,
  ASNParams,
  GRNParams,
  InternationalInventoryParams,
  ASN_GRN_PO_search_params,
  Sales_Order_Params,
  Sales_Purchase_Order_Params,
  Sales_GRN_Params,
  ROParams
} from './api_params';
import { transformObjectToString } from './common';

const createPOParams = (type, selectedFilters, state, pagination, options) => {
  const paramsObj = {
    poParams: new PurchaseOrderParams(
      transformObjectToString(selectedFilters?.po_number),
      transformObjectToString(selectedFilters?.po_type),
      state === 'ALL' ? undefined : state,
      transformObjectToString(selectedFilters?.brand),
      transformObjectToString(selectedFilters?.buyer),
      transformObjectToString(selectedFilters?.seller),
      transformObjectToString(selectedFilters?.currency),
      pagination.current - 1,
      pagination.pageSize,
      'updatedOn',
      'DESC',
      type,
      selectedFilters?.filter_date_on,
      selectedFilters?.start_date,
      selectedFilters?.end_date,
      options
    ),
    asnParams: new ASNParams(
      transformObjectToString(selectedFilters?.asn_number),
      transformObjectToString(selectedFilters?.po_number),
      transformObjectToString(selectedFilters?.invoice_number),
      state === 'ALL' ? undefined : state,
      transformObjectToString(selectedFilters?.warehouse),
      pagination.current - 1,
      pagination.pageSize,
      'updatedOn',
      'DESC',
      selectedFilters?.filter_date_on,
      selectedFilters?.start_date,
      selectedFilters?.end_date,
      transformObjectToString(selectedFilters?.brand),
      transformObjectToString(selectedFilters?.vendor),
      options
    ),
    grnParams: new GRNParams(
      transformObjectToString(selectedFilters?.grn_type),
      transformObjectToString(selectedFilters?.grn_number),
      transformObjectToString(selectedFilters?.po_number),
      transformObjectToString(selectedFilters?.asn_number),
      transformObjectToString(selectedFilters?.invoice_number),
      state === 'ALL' ? undefined : state,
      pagination.current - 1,
      pagination.pageSize,
      'updatedOn',
      'DESC',
      selectedFilters?.filter_date_on,
      selectedFilters?.start_date,
      selectedFilters?.end_date,
      options
    ),

    inventoryParams: new InternationalInventoryParams(
      pagination.current - 1,
      pagination.pageSize,
      'updatedOn',
      'DESC',
      options
    )
  };

  return paramsObj;
};

const create_asn_grn_po_search_params = (value, type) => {
  const paramsObj = {
    asn_grn_po_search_params: new ASN_GRN_PO_search_params(
      value.trim(),
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      type
    )
  };
  return paramsObj;
};

const createCommentsParams = (id) => {
  const paramsObj = {
    commentsParams: new CommentsParams(id)
  };
  return paramsObj;
};

const createAttachmentParams = (fileName, referenceId, fileType) => {
  const paramsObj = {
    attachmentParams: new AttachmentParams(fileName, referenceId, fileType)
  };
  return paramsObj;
};

const createMDMParams = (type) => {
  const paramsObj = {
    mdmEntityParams: new MDM_Entity_params(...[, , type]),
    terms_conditions_params: new Terms_Conditions_Params(type),
    brandsParams: new Brands_Params()
  };
  return paramsObj;
};

const createSOParams = (selectedFilters, state, pagination, section, options) => {
  const paramsObj = {
    soParams: new Sales_Order_Params(
      transformObjectToString(selectedFilters?.invoice_type),
      transformObjectToString(selectedFilters?.seller),
      transformObjectToString(selectedFilters?.buyer),
      transformObjectToString(selectedFilters?.po_number),
      transformObjectToString(selectedFilters?.so_number),
      state === 'ALL' ? undefined : state,
      transformObjectToString(selectedFilters?.brand),
      section !== 'summary' ? pagination.current - 1 : undefined,
      section !== 'summary' ? pagination.pageSize : undefined,
      section !== 'summary' ? 'updatedOn' : undefined,
      section !== 'summary' ? 'DESC' : undefined,
      section !== 'summary' ? 'createdOn' : undefined,
      selectedFilters?.start_date,
      selectedFilters?.end_date,
      options,
      transformObjectToString(selectedFilters?.warehouse)
    ),
    salesPurchaseOrderParams: new Sales_Purchase_Order_Params(
      transformObjectToString(selectedFilters?.po_number),
      transformObjectToString(selectedFilters?.invoice_type),
      state === 'ALL' ? undefined : state,
      transformObjectToString(selectedFilters?.seller_id),
      transformObjectToString(selectedFilters?.buyer_billing_id),
      transformObjectToString(selectedFilters?.brand_id),
      section !== 'summary' ? pagination.current - 1 : undefined,
      section !== 'summary' ? pagination.pageSize : undefined,
      section !== 'summary' ? 'updatedOn' : undefined,
      section !== 'summary' ? 'DESC' : undefined,
      'creationDate',
      selectedFilters?.start_date,
      selectedFilters?.end_date,
      options
    ),
    salesGRNParams: new Sales_GRN_Params(
      undefined,
      transformObjectToString(selectedFilters?.grn_number),
      transformObjectToString(selectedFilters?.po_number),
      transformObjectToString(selectedFilters?.so_number),
      state === 'ALL' ? undefined : state,
      selectedFilters?.filter_date_on,
      selectedFilters?.start_date,
      selectedFilters?.end_date,
      'updatedOn',
      'DESC',
      pagination.current - 1,
      pagination.pageSize
    ),
    roParams: new ROParams(
      undefined,
      transformObjectToString(selectedFilters?.grn_number),
      transformObjectToString(selectedFilters?.po_number),
      transformObjectToString(selectedFilters?.so_number),
      state === 'ALL' ? undefined : state,
      selectedFilters?.filter_date_on,
      selectedFilters?.start_date,
      selectedFilters?.end_date,
      'updatedOn',
      'DESC',
      pagination.current - 1,
      pagination.pageSize
    )
  };

  return paramsObj;
};

const userParams = (pagination) => ({
  page_no: pagination.current - 1,
  page_size: pagination.pageSize
});

export {
  createPOParams,
  create_asn_grn_po_search_params,
  createCommentsParams,
  createAttachmentParams,
  createMDMParams,
  createSOParams,
  userParams
};
